import * as React from 'react';

import { ensureValue } from '@rematter/ui-web';

export const useMultiRef = <T extends HTMLElement>() => {
  const refs = React.useRef<Map<string, React.RefObject<T | null>>>(new Map());

  const getRefByKey = React.useCallback((key: string) => {
    const ref = refs.current.get(key);
    if (!ref) {
      refs.current.set(key, React.createRef<T>());
    }
    return ensureValue(refs.current.get(key));
  }, []);

  return getRefByKey;
};
